<template>
  <!-- {{ clases }} -->

  <TabView
    class="tabview-custom transaction-tabs"
    v-model:activeIndex="clases"
    ref="tabview4"
    :scrollable="true"
    @keyup.enter="handleKeyDown"
  >
    <TabPanel v-for="(tab, index) in TabArray" :key="index">
      <template #header>
        <div
          class="d-flex align-items-center settabheight"
          @click="TabClick(tab, index), TabGetIndex(index)"
        >
          <img :src="tab.Image" class="DetailsIcon" />
          <span style="padding: 0px 7px">{{ $t(`${tab["Path"]}`) }}</span>
        </div>
      </template>
      <!-- {{ activeTabIndex }}
      {{index}} -->
      <div v-if="activeTabIndex === index">
        <!-- g -->
        <!-- {{ tab.FixedHref }} -->
        <component
          :is="tab.FixedHref"
          :propsParams="paramValues"
          :FunctionRights="functionRights"
          :Addstatus="false"
          :tstatus="false"
          @StoreCode="storeCode"
        />
      </div>
    </TabPanel>
  </TabView>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  watch,
  reactive,
  onUnmounted,
  computed,
} from "vue";
import { useRouter, useRoute } from "vue-router";

import InboundRequestTableview from  "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/inboundrequest/InboundRequestTableview.vue";
import OutboundRequestTableview from  "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/outboundrequest/OutboundRequestTableview.vue";
import IndentTemplateTableview from  "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/indentTemplate/IndentTemplateTableview.vue";
import MastersService from  "../../../../../../modules/Inventory/Service/MastersService";
import { useInventoryStore } from  "../../../../../../modules/Inventory/stores/Index";

export default defineComponent({
  components: {
    InboundRequestTableview,
    OutboundRequestTableview,
    IndentTemplateTableview,
  },

  props: {},

  setup(props) {
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const route = useRoute();
    const inventoryStore = useInventoryStore();
    const router = useRouter();

    let menuarray: any = ref([]);
    let TabArray: any = ref([]);
    const activeTabIndex = ref(0);
    const clases = ref(0);

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    let functionRights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    const paramValues = ref({
      Id: "",
      Type: "",
      status: 0,
      storename: "",
    });

    let StoreCode = ref();

    const storeCode = (data) => {
      StoreCode.value = data;
    };
    watch(
      () => inventoryStore.SubTab,
      (newVal: any) => {
        debugger;
        if (inventoryStore.SubTab == 157 || inventoryStore.SubTab == 158) {
          let WatchEntityId = {
            EntityId: inventoryStore.SubTab,
          };
          let index = 0;
          if (inventoryStore.SubTab == 157) {
            index = 1;
          } else if (inventoryStore.SubTab == 158) {
            index = 0;
          }
          TabClick(WatchEntityId, index);
          TabGetIndex(index);
        }
      }
    );
    watch(
      () => route.query.Id,
      (newVal: any) => {
        debugger;
        paramValues.value.Id = newVal;
        paramValues.value.Type = route.query.Type as string;
        paramValues.value.status = Number(route.query.status);
        paramValues.value.storename = route.query.storename as string;

        // clases.value = 0;

        clases.value = 0;
        let TabIndexval = localStorage.getItem("RequestSubTabIndex");
        let TabIndexvalDataData;
        if (TabIndexval !== null) {
          TabIndexvalDataData = JSON.parse(TabIndexval);
        }
        // alert(TabIndexvalDataData.Indexval)
        clases.value = TabIndexvalDataData.Indexval;
        activeTabIndex.value = TabIndexvalDataData.Indexval;
      }
    );

    onMounted(() => {
      paramValues.value.Id = String(route.query.Id);
      paramValues.value.Type = route.query.Type as string;
      paramValues.value.status = Number(route.query.status);
      paramValues.value.storename = route.query.storename as string;

      LoadMenus();

      let TabIndexval = localStorage.getItem("RequestSubTabIndex");
      let TabIndexvalDataData;
      if (TabIndexval !== null) {
        TabIndexvalDataData = JSON.parse(TabIndexval);
      }
      // alert(TabIndexvalDataData.Indexval)

      clases.value = TabIndexvalDataData.Indexval;
      activeTabIndex.value = TabIndexvalDataData.Indexval;
    });

    async function LoadMenus() {
      debugger;
      let response = await MastersService.GetMenus(
        5,
        rolesData.RoleId,
        usersData.OrganizationId
      );

      console.log("MenuListStoreTabDetails", response["result"]);
      menuarray.value = response["result"];

      BindTabsByStore(menuarray.value);
    }

    function BindTabsByStore(MenuArray) {
      debugger;
      TabArray.value = MenuArray.filter((item) =>
        item.StoreRights.split(",").includes(route.query.status)
      );

      console.log(route.query.status);
      console.log(TabArray.value);
      debugger;
      if (inventoryStore.SubTab == null) {
        // if (TabArray.value.length > 0) {
        //   TabClick(TabArray.value[0], 0);
        // }
        if (TabArray.value.length > 0) {
          let TabIndexval = localStorage.getItem("RequestSubTabIndex");
          let TabIndexvalDataData;
          if (TabIndexval !== null) {
            TabIndexvalDataData = JSON.parse(TabIndexval);
          }
          if (clases.value !== 0) {
            TabIndexvalDataData.Indexval = clases.value;
          } else {
            TabIndexvalDataData.Indexval = clases.value;
          }
          //alert(TabIndexvalDataData.Indexval);
          console.log("Tabarray", TabArray.value);
          TabClick(
            TabArray.value[TabIndexvalDataData.Indexval],
            TabIndexvalDataData.Indexval
          );
          // TabClick(TabArray.value[0], 0);
        }
      } else {
        if (inventoryStore.SubTab == 157 || inventoryStore.SubTab == 158) {
          let WatchEntityId = {
            EntityId: inventoryStore.SubTab,
          };
          let index = 0;
          if (inventoryStore.SubTab == 157) {
            index = 1;
          } else if (inventoryStore.SubTab == 158) {
            index = 0;
          }
          TabClick(WatchEntityId, index);
          TabGetIndex(index);
        }
        inventoryStore.SubTab = null;
      }
    }
    function TabGetIndex(index) {
      activeTabIndex.value = index;
      clases.value = index;
    }
    async function TabClick(SubMenuDetails, index) {
      debugger;
      activeTabIndex.value = index;
      clases.value = index;

      console.log("SubMenuEntityId", SubMenuDetails.EntityId);

      let InstantEntityId = {
        EntityId: SubMenuDetails.EntityId,
      };
      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));

      let TabIndex = {
        Indexval: index,
      };
      // alert(index);
      localStorage.removeItem("RequestSubTabIndex");
      localStorage.setItem("RequestSubTabIndex", JSON.stringify(TabIndex));

      const response = await MastersService.CheckMenuRights(
        InstantEntityId.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          functionRights.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          functionRights.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          functionRights.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          functionRights.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      functionRights.value.EntityId = InstantEntityId.EntityId;
      functionRights.value.Create = Rights.value.Create;
      functionRights.value.Update = Rights.value.Update;
      functionRights.value.Read = Rights.value.Read;
      functionRights.value.Delete = Rights.value.Delete;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      debugger;
      if (event.key === "ArrowLeft" && clases.value > 0) {
        clases.value--; // Move to the previous tab on left arrow press
      } else if (
        event.key === "ArrowRight" &&
        clases.value < TabArray.length - 1
      ) {
        clases.value++; // Move to the next tab on right arrow press
      }
      activeTabIndex.value = clases.value;
    };

    return {
      TabGetIndex,
      menuarray,
      TabClick,
      functionRights,
      TabArray,
      activeTabIndex,
      handleKeyDown,
      clases,
      storeCode,
      paramValues,
    };
  },
});
</script>
